export default __webpack_public_path__ + "static/media/Blight.fdbcebad.jpg";